import { RootState } from 'store';

const AccountInvoiceCodes = (state: RootState) => state.supportAtHome.accountCodes;

export const selectAccountInvoiceCodes = (state: RootState) => AccountInvoiceCodes(state).rows;
export const selectAccountInvoiceCodesLoading = (state: RootState) => AccountInvoiceCodes(state).loading;
